import { withStyles, Theme } from '@material-ui/core';
import React from 'react';
import { useRecoilValue } from 'recoil';
import { ProductPopulates, ProductParameterTypes } from '../../../@sprinx/knihovka-types';
import { isAuthenticatedState } from '../../../api/appState';
import useConvertProductParametersToDisplay from '../../../api/products/productParameters';
import { productDetailAuthenticatedParameterCodes } from '../../../config';
import Parameter from './Parameter';

const ParameterGroup = ({
  classes = {},
  label,
  parameters,
  types,
}: {
  classes?: Partial<Record<'root' | 'label' | 'content', string>>;
  label: React.ReactNode;
  parameters: Required<ProductPopulates['parameters']>['parameters'];
  types: ProductParameterTypes;
}): JSX.Element | null => {
  const isAuthenticated = useRecoilValue(isAuthenticatedState);
  const convertPatameters = useConvertProductParametersToDisplay();
  const convertedParameters = convertPatameters(types, parameters);

  return convertedParameters ? (
    <div className={classes.root}>
      <div className={classes.label}>{label}</div>
      <div className={classes.content}>
        {convertedParameters.map((param) => {
          return productDetailAuthenticatedParameterCodes.includes(param.code) ? (
            isAuthenticated && <Parameter key={param.code} label={param.label} value={param.value} unit={param.unit} />
          ) : (
            <Parameter key={param.code} label={param.label} value={param.value} unit={param.unit} />
          );
        })}
      </div>
    </div>
  ) : null;
};

const ParameterGroupStyled = withStyles((theme: Theme) => ({
  root: {},
  label: {
    ...theme.typography.h4,
    padding: theme.spacing(3, 0),
  },
  content: {},
}))(ParameterGroup) as typeof ParameterGroup;

export default ParameterGroupStyled;
